import { useHistory } from 'react-router-dom';

export type AiAgentNavigationState = {
  initialMessage?: string;
  autoSend?: boolean;
  handoff?: boolean;
  entrySource?: string;
};

type NavigateToAiAgentParams = {
  societyId: string;
  initialMessage?: string;
  autoSend?: boolean;
  handoff?: boolean;
  entrySource?: string;
};

export const useNavigateToAiAgent = () => {
  const history = useHistory();

  return ({
    societyId,
    initialMessage,
    autoSend = true,
    handoff = false,
    entrySource,
  }: NavigateToAiAgentParams) => {
    if (!societyId) return;

    if (handoff) {
      history.push(`/sociedad-ai/${societyId}`, {
        handoff: true,
        entrySource: entrySource || 'embed_handoff',
      } as AiAgentNavigationState);
      return;
    }

    const trimmed = initialMessage?.trim();
    if (!trimmed) return;

    history.push(`/sociedad-ai/${societyId}`, {
      initialMessage: trimmed,
      autoSend,
      entrySource: entrySource || 'direct_url',
    } as AiAgentNavigationState);
  };
};
